import { isBrowser } from '@/helpers/BrowserHelper';

/* 후원 > 개인정보 암호화키 */
export const SESSION_STORAGE_KEY__DONATE_CRYPTO = '__donateCrypto';
/* 마이페이지 > 개인정보 > 인증토큰 */
export const SESSION_STORAGE_KEY__MYPAGE_AUTH = '__myinfoAuth';
/* 소급모듈 > 개인정보 암호화키 */
export const SESSION_STORAGE_KEY__OVERDUE_CRYPTO = '__overdueCrypto';
export interface SESSION_STORAGE_KEY__OVERDUE_CRYPTO__TYPE {
  key: string;
  cert: string;
  expiry: number;
  isSecureContext: boolean;
  donorId: string;
}
export const SESSION_STORAGE_KEYS__DONATE_TRACKING_CODE = [
  `utm_campaign`,
  `utm_source`,
  `utm_medium`,
  `utm_content`,
  `utm_term`,
  `utm_id`,
  `utm_agency`,
  `digital_material`,
]; // backend 키 선 등록 필요

/**
 * 빌드타임에는 sessionStorage가 없어 에러나기 때문에, Storage를 별도로 정의하여 활용
 */
const SessionStorage = {
  // 기본 함수
  getItem(key: string): string | null {
    return isBrowser ? sessionStorage.getItem(key) : null;
  },
  setItem(key: string, value: string): void {
    if (isBrowser) {
      sessionStorage.setItem(key, value);
    }
  },
  removeItem(key: string): void {
    if (isBrowser) {
      sessionStorage.removeItem(key);
    }
  },
  clear(): void {
    if (isBrowser) {
      sessionStorage.clear();
    }
  },
};

export default SessionStorage;
